module.exports = "/images/bg_story_banner.jpg?389a7351fe19460bb91e7bb3fff58a64";